export { default as createHashHistory } from './hash';
export { default as createPathHistory } from './path';